<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" epub:type="toc" id="_idContainer004">
<p class="Chapter-Headers">Contents</p>
</div>
<div class="_idGenObjectStyleOverride-1" epub:type="toc" id="_idContainer006">
<p class="Contents top1"><a href="#/AlongTheWay_ebook3#_idTextAnchor001">Foreword by Dr. Harry Dumay, Elms President</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook4#_idTextAnchor003">Introduction by Father Mark S. Stelzer, STD</a></p>
<p class="TOC-Subhead"><a href="#/AlongTheWay_ebook5#_idTextAnchor004">Part One</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook6#_idTextAnchor005">Original Foreword</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook7#_idTextAnchor006">First Mass—Father Francis Reilly</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook8#_idTextAnchor007">25th Anniversary of Ordination—Father Leo O’Neill</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook9#_idTextAnchor008">Liturgy of Christian Burial—Sister Thomasine O’Connor, SNDdeN</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook10#_idTextAnchor009">National Honor Society <span class="CharOverride-4">I</span>nduction</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook11#_idTextAnchor010">150th Anniversary—Sisters of Notre Dame de Namur</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook12#_idTextAnchor011">Day of Recollection for Priests</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook13#_idTextAnchor012">Christmas</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook14#_idTextAnchor013">Celebration of Special Anniversaries—Sisters of St. Joseph</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook15#_idTextAnchor014">Retreat Conference</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook16#_idTextAnchor015">Liturgy of Christian Burial—Nora Brosnan Crean</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook17#_idTextAnchor016">First Mass—Father Christopher Connelly</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook18#_idTextAnchor017">Liturgy of Christian Burial—William “Bill” Crean</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook19#_idTextAnchor018">Saint Patrick’s Day Mass</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook20#_idTextAnchor019">Saint Jude Novena</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook21#_idTextAnchor020">A Letter to His Nephew</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook22#_idTextAnchor021">Liturgy of Christian Burial—Father Cyril Burns</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook23#_idTextAnchor022">Farewell Mass</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook24#_idTextAnchor023">100th Anniversary—Saint Mary’s School</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook25#_idTextAnchor024">Liturgy of Christian Burial—Father John Johnson</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook26#_idTextAnchor025">Month’s Mind Mass—Monsignor Thomas Devine</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook27#_idTextAnchor026">Easter Vigil—2002</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook28#_idTextAnchor027">Liturgy of Christian Burial—Sister Helen Elizabeth</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook29#_idTextAnchor028">Liturgy of Christian Burial—Monsignor John Harrington</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook30#_idTextAnchor029">Special Anniversaries—Sisters of Providence</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook31#_idTextAnchor030">Christmas Letter to the Andrews Family</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook32#_idTextAnchor031">Last Will and Testament</a></p>
<p class="TOC-Subhead"><a href="#/AlongTheWay_ebook33#_idTextAnchor032">Part  Two</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook34#_idTextAnchor033">The Creans, Westfield, and Saint Mary’s Parish, by Jane F. Morrissey, SSJ, PhD</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook35#_idTextAnchor034">Reflections on American Catholic History</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook36#_idTextAnchor036">Roots and Realities of a Priestly People</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook37#_idTextAnchor037">Father Hugh Crean:Master Builder of Bridges, by Mary B. Johnson, SNDdeN, PhD</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook38#_idTextAnchor038">Shadow and Light, Doubt and Faith: Signs of the Sacred, by Peter A. DePergola III, PhD</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook39#_idTextAnchor039">Priesthood: A Sacrament of Friendship</a></p>
<p class="Contents ParaOverride-1"><a href="#/AlongTheWay_ebook40#_idTextAnchor041">Afterword by Hugh Andrews</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook41#_idTextAnchor042">Contributor Biographies</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook42#_idTextAnchor043">Appendix</a></p>
<p class="Contents"><a href="#/AlongTheWay_ebook43#_idTextAnchor044">Inspiring Words fromFather Hugh F. Crean</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlongTheWay_ebook-2.vue?08adf0be